import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { manualPaymentSync } from "../../../../locales/en";
import { INVOICE_DETAILS } from "../../../../route/paths";
import { formatFTNumber } from "../../../../utils/utils";

const QuoteIdCell = ({ row }) => {
  const displayValue = formatFTNumber(row?.original?.fmfbQuoteId);

  return row?.original?.fmfbQuoteId ? (
    <Link to={INVOICE_DETAILS(row?.original?.quoteId)}>{displayValue}</Link>
  ) : (
    <span>{displayValue}</span>
  );
};

QuoteIdCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      fmfbQuoteId: PropTypes.any,
      quoteId: PropTypes.any
    })
  }).isRequired
};

const StatusCell = ({ value }) => {
  const displayText = value ? "Yes" : "No";

  return (
    <span className={value ? "text-success" : "text-danger"}>
      {displayText}
    </span>
  );
};

StatusCell.propTypes = {
  value: PropTypes.bool
};

const Column = () => {
  return [
    {
      id: "quoteId",
      Header: manualPaymentSync?.table?.quoteId,
      accessor: "fmfbQuoteId",
      sortable: true,
      Cell: QuoteIdCell
    },
    {
      id: "isInvoiceUpdated",
      Header: manualPaymentSync?.table?.status,
      accessor: "isInvoiceUpdated",
      sortable: true,
      Cell: StatusCell
    }
  ];
};

export default Column;
